// extracted by mini-css-extract-plugin
module.exports = {"actions":"filtersBoSearchRequestId_actions__1FX4i","requestId":"filtersBoSearchRequestId_requestId__2Wewn"};